export default function () {
    return (
        <hr className="h-0 border-t-2 border-gray-200 my-4"/>
    )
}